// extracted by mini-css-extract-plugin
export default {"tag":"ProgramStatusTag-module__tag--lip6O","large":"ProgramStatusTag-module__large--P76jy","status":"ProgramStatusTag-module__status--Ij_Lj"};